import { useState, useEffect, useContext } from 'react';
import './assets/styles/style.css';
import { Main, Sidebar } from './components/index';
import { ModeContext } from './components/ModeContext';

import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { Box, Typography, Drawer, useMediaQuery } from '@mui/material';
import LoginPage from './components/LoginPage';
import ButtonLogout from './components/ButtonLogout';
import ButtonSetting from './components/ButtonSetting';
import SettingsPage from './components/SettingsPage';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import MenuIcon from '@mui/icons-material/Menu';
import { IconButton } from '@mui/material';
import ButtonHome from './components/ButtonHome';
import VersionChecker from './components/VersionChecker';
// 他のimportは省略

const App = () => {
  const { loginInfo, setLoginInfo } = useContext(ModeContext);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(true);

  // レスポンシブ判定: 768px以下をモバイル、1024px以下をタブレットとする
  const isMobile = useMediaQuery('(max-width:768px)');
  const isTablet = useMediaQuery('(min-width:769px) and (max-width:1024px)');

  // モバイル時はサイドバーをデフォルトで閉じる
  useEffect(() => {
    if (isMobile) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  }, [isMobile]);

  const toggleSidebar = () => {
    setOpen(!open);
  };

  // ログイン情報をlocalStorageから読み込みContextにセット
  const handleLogin = async () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const storedId = localStorage.getItem('id');
        const storedCompId = localStorage.getItem('compId');
        const storedCompName = localStorage.getItem('compName');
        const userId = localStorage.getItem('userId');
        const storedUserName = localStorage.getItem('userName');
        const role = localStorage.getItem('authorityId');
        const prompt = localStorage.getItem('prompt');
        const data = localStorage.getItem('data');
        const faqapi = localStorage.getItem('faqapi');
        const webhook = localStorage.getItem('webhook');

        const isLoggedIn = storedCompId && storedCompName && storedUserName && role;

        if (isLoggedIn) {
          setLoginInfo({
            id: storedId,
            compId: storedCompId,
            compName: storedCompName,
            userId:userId,
            userName: storedUserName,
            authorityId: role,
            prompt: JSON.parse(prompt),
            data:JSON.parse(data),
            faqapi:JSON.parse(faqapi),
            isLoggedIn: true,
            webhook:JSON.parse(webhook),
          });
          setLoading(false);
          console.log('ログイン情報の取得完了');
        } else {
          setLoginInfo({ isLoggedIn: false });
        }
        resolve();
      }, 500);
    });
  };

  useEffect(() => {
    const fetchLoginStatus = async () => {
      setLoading(true);
      const loggedInStatus = localStorage.getItem('isLoggedIn');
      if (loggedInStatus === 'true') {
        await handleLogin();
      } else {
        setLoginInfo({ isLoggedIn: false });
        setLoading(false);
      }
    };
    fetchLoginStatus();

  }, []);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        ローディング中...
      </div>
    );
  }

  return (
    <div className="container">
      <Router>
        <Box sx={{width: "100%", height: '100vh', display: 'flex', flexDirection: 'column' }}>

          <Box
            sx={{
              width: "100%",
              height: { xs: "48px", sm: "40px" },
              minHeight: { xs: "48px", sm: "40px" }, 
              flexShrink: 0 ,
              bgcolor: "#555555",
              display: "flex",
              alignItems: "center",
              px: { xs: 1, sm: 2 },
              justifyContent: "space-between",
            }}
          >

            <Box sx={{ display: "flex", alignItems: "center" }}>
              {/* モバイル時: ハンバーガーメニュー表示 */}
              {isMobile && loginInfo.isLoggedIn && (
                <IconButton
                  onClick={toggleSidebar}
                  sx={{ color: "white", mr: 0.5, p: "6px" }}
                  aria-label="メニュー"
                >
                  <MenuIcon />
                </IconButton>
              )}
              <img
                src="/images/CI_Brandmark_TH_White.png"
                alt="Logo"
                style={{ height: isMobile ? "32px" : "40px", cursor: "pointer" }}
                onClick={() => window.location.reload()}
              />
              <Typography
                variant="h6"
                sx={{
                  ml: { xs: 1, sm: 4 },
                  color: "white",
                  fontFamily: "Montserrat, sans-serif",
                  fontWeight: 500,
                  letterSpacing: "0.5px",
                  fontSize: { xs: "0.9rem", sm: "1.25rem" },
                  whiteSpace: "nowrap",
                }}
              >
                寺岡コンシェルジュ
              </Typography>
            </Box>

            {loginInfo.isLoggedIn && (
              <>
                {/* タブレット・PC時のみユーザー情報を表示 */}
                <Box
                  key={`${loginInfo.compId}-${loginInfo.compName}-${loginInfo.userName}`}
                  sx={{
                    display: { xs: "none", md: "flex" },
                    color: "white",
                    fontSize: "13px",
                    ml: "auto",
                    mr: 4,
                  }}
                >
                  顧客ID: {loginInfo.compId} / {loginInfo.compName} {loginInfo.userName}
                </Box>
                <Box sx={{ display: "flex", gap: { xs: 0.5, sm: 1 }, alignItems: "center", ml: "auto", mr: { xs: 0, sm: 4 } }}>
                  <ButtonHome />
                  {loginInfo.authorityId !== 'store' && <ButtonSetting />}
                  <ButtonLogout />
                </Box>
              </>
            )}
          </Box>

          {loginInfo.isLoggedIn && <VersionChecker />}
          <Box sx={{ display: "flex", flex: 1, height: "calc(100vh - 40px)", overflow: "hidden" }}>
            <Routes>
              <Route
                path="/"
                element={
                  loginInfo.isLoggedIn ? (
                    <Box sx={{ display: "flex", width: "100%", height: "100%" }}>
                      {/* モバイル時: Drawerでサイドバーを表示 */}
                      {isMobile ? (
                        <Drawer
                          anchor="left"
                          open={open}
                          onClose={() => setOpen(false)}
                          sx={{
                            '& .MuiDrawer-paper': {
                              width: '80vw',
                              maxWidth: '320px',
                              top: '48px',
                              height: 'calc(100vh - 48px)',
                            },
                          }}
                          ModalProps={{
                            keepMounted: true, // モバイルパフォーマンス向上
                          }}
                        >
                          <Sidebar chatHistorya={[]} wkuser={loginInfo?.id || ''} />
                        </Drawer>
                      ) : (
                        /* PC・タブレット時: 従来のflex表示 */
                        <>
                          <Box
                            sx={{
                              flex: open ? (isTablet ? 3 : 2) : 0,
                              bgcolor: "grey.200",
                              display: open ? "flex" : "none",
                              flexDirection: "column",
                              height: "100%",
                              overflow: "hidden",
                            }}
                          >
                            <Sidebar chatHistorya={[]} wkuser={loginInfo?.id || ''} />
                          </Box>
                          {/* 折りたたみボタン */}
                          <Box
                            sx={{
                              width: '12px',
                              backgroundColor: '#eee',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              cursor: 'pointer',
                              zIndex: 1300,
                            }}
                          >
                            <IconButton
                              size="small"
                              onClick={toggleSidebar}
                              disableRipple
                              sx={{
                                '&:hover': {
                                  backgroundColor: 'transparent'
                                },
                                backgroundColor: 'transparent',
                                padding: '0px'
                              }}
                            >
                              {open ? 
                              <ChevronLeftIcon sx={{ fontSize: '1rem', transform: 'scaleY(5)' }}/> : 
                              <ChevronRightIcon sx={{ fontSize: '1rem', transform: 'scaleY(5)' }}/>}
                            </IconButton>
                          </Box>
                        </>
                      )}
  {/* Main */}
                      <Box
                        sx={{
                          flex: isMobile ? 1 : 8,
                          bgcolor: "grey.200",
                          display: "flex",
                          flexDirection: "column",
                          overflow: 'hidden',
                          width: isMobile ? "100%" : "auto",
                        }}
                      >
                        <Main wkuser={loginInfo.id} />
                      </Box>
                    </Box>
                  ) : (
                    <Navigate to="/login" replace />
                  )
                }
              />
              <Route
                path="/settings"
                element={loginInfo.isLoggedIn ? <SettingsPage /> : <Navigate to="/login" replace />}
              />
              <Route path="/login" element={<LoginPage onLogin={handleLogin} />} />
            </Routes>
          </Box>
        </Box>
      </Router>
    </div>
  );
};

export default App;
